import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography } from 'src/components/CustomTypography';
import { getChannelPerformanceLabel } from 'src/data/channel';
import { getResourceDocumentLabel } from 'src/data/performance';

import { useStyles } from './useStyles';

export const PerformanceRowsLimitTooltip = ({ className, connectedAccounts }) => {
  const styles = useStyles();

  return (
    <div className={cx(className, styles.root)}>
      {connectedAccounts?.length > 0 && (
        <>
          <CustomTypography
            className={styles.header}
            variant="semiBold14"
          >
            Data source
          </CustomTypography>
          <CustomTypography variant="regular14">
            {connectedAccounts.map((account) => (
              <span
                key={account?.id}
                className={styles.account}
              >
                &bull; {account?.name} (
                <span>
                  {getChannelPerformanceLabel(account?.channel) ||
                    getResourceDocumentLabel(account?.channel)}
                </span>
                )
              </span>
            ))}
          </CustomTypography>
          <br />
        </>
      )}
      <CustomTypography
        className={styles.header}
        variant="semiBold14"
      >
        What are performance data rows?
      </CustomTypography>
      <CustomTypography variant="regular14">
        Power your generations with insights from your best performing copy with Anyword&apos;s Copy
        Intelligence Platform. Performance data rows represent the number of copy assets you
        integrate with Anyword. The number of rows is affected by the amount of integrations you
        have and the granularity of the data related to them.
      </CustomTypography>
    </div>
  );
};

PerformanceRowsLimitTooltip.displayName = 'PerformanceRowsLimitTooltip';
PerformanceRowsLimitTooltip.propTypes = {
  className: PropTypes.string,
  connectedAccounts: PropTypes.array,
};
PerformanceRowsLimitTooltip.defaultProps = {
  className: '',
  connectedAccounts: [],
};
